import { type MouseEvent, useCallback } from "react";
import { useDownloadDocument } from "@kanda-libs/ks-component-ts";
import { useSelector } from "react-redux";
import { selectors } from "store";
import jobSelectors from "store/selectors/job";

export interface DownloadEpvsButtonPropsHook {
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  isSubmitting: boolean;
  isSolar: boolean;
  isLoading: boolean;
}

export default function useDownloadEpvsButtonProps(): DownloadEpvsButtonPropsHook {
  const isLoading = useSelector(selectors.getIsLoading);
  const job = useSelector(jobSelectors.getEntity);

  const isSolar = job?.job_type === "solar";
  const epvs = isSolar ? job?.job_documents?.[0]?.id : null;

  const { isSubmitting, downloadDocument } = useDownloadDocument();

  /**
   * Handles job download as pdf logic
   */
  const handleDownload = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();
      if (epvs) {
        downloadDocument(epvs);
      }
    },
    [epvs, downloadDocument]
  );

  return {
    onClick: handleDownload,
    isSubmitting,
    isSolar,
    isLoading,
  };
}
